import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingBlock from '../../components/loading-block/LoadingBlock';
import { useCanvaAuthContext } from '../../contexts/canva-auth-context/CanvaAuthContext';

export interface RequireCanvaAuthProps {
  children: JSX.Element,
}

const RequireCanvaAuth: React.FC<RequireCanvaAuthProps> = ({
  children,
}) => {
  const { isAuthorized, isAuthorizationLoading } = useCanvaAuthContext();
  const { pathname, search } = useLocation();

  if (isAuthorizationLoading) {
    return <LoadingBlock />;
  }

  return isAuthorized
    ? children
    : <Navigate to="/marketing/canva/login" replace state={{ from: pathname + search }} />;
};

export default RequireCanvaAuth;
